import ProductAdjustment from './product_adjustment.vue';

export default ProductAdjustment;
